<template>
    <el-container>
        <el-container>
            <!-- 中间内容 -->
            <el-main>
                <h2 class="depTitle">学科管理</h2>
                <div class="RightDiv">
                    <el-form :model="searchForm" class="searForm">
                        <div class="table-title">
                            <div>
                                <el-input v-model="searchForm.nameLike" placeholder="学科名称" clearable prefix-icon="el-icon-search" @keyup.enter.native="searchList" @blur="searchList" @clear="searchList">
                                </el-input>
                            </div>
                            <div class="index-add">
                                <el-button type="primary" @click="depaddKeshi">添加学科</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>
                <el-table :data="tableData" border center>
                    <el-table-column type="index" label="序号" width="55" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="学科名称" align="center">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" width="200" align="center">
                        <template slot-scope="scope">
                            <div class="remakSty">
                                {{scope.row.remark}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="更新时间" align="center" width="160">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="250">
                        <template style="display: flex" slot-scope="scope">
                            <el-button size="mini" type="primary" @click="editKeshi(scope.row)"><i class="el-icon-edit"></i></el-button>
                            <el-button size="mini" type="danger" @click="deleteKeshi(scope.row)"><i class="el-icon-delete-solid"></i></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="total">
                </el-pagination>
            </el-main>
        </el-container>
        <!-- 点击添加学科弹出框 -->
        <el-dialog :title="addName" :visible.sync="AdddialogVisible" width="360px" :before-close="AdddialogVisibleClose">
            <el-form :model="AddDateModel" ref="AddDateRef" :rules="AddDateRules" label-width="100px">
                <el-form-item label="学科名称：" prop="name">
                    <el-input v-model="AddDateModel.name" placeholder="请填写学科"></el-input>
                </el-form-item>

                <el-form-item label="备注：" prop="text">
                    <el-input @input="change($event)"   maxlength="250" show-word-limit placeholder="请填写备注" type="textarea" v-model="AddDateModel.text"></el-input>
                </el-form-item>

                <el-form-item class="depar-dia btnCen">
                    <el-button v-if="addDepClick" type="primary" :loading="addDepClickKing" @click="parmen">{{btnText}}</el-button>
                    <el-button v-else type="info" :loading="addDepClickKing"></el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-container>
</template>

<script>
import _qs from "qs";
export default {
    data() {
        var nameSpace = async (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入学科名称"));
            } else if (value) {
                // console.log(this.addName);
                if (this.addName == "修改学科") {
                    if (this.reayName == value) {
                        callback();
                    } else {
                        let data = _qs.stringify({
                            name: value,
                        });
                        let res = await this.$axios.judgeHosDiscipline(data);
                        // console.log(res);
                        if (res.data.code == 200) {
                            callback();
                        } else {
                            callback(new Error(res.data.msg));
                        }
                    }
                } else {
                    let data = _qs.stringify({
                        name: value,
                    });
                    let res = await this.$axios.judgeHosDiscipline(data);
                    // console.log(res);
                    if (res.data.code == 200) {
                        callback();
                    } else {
                        callback(new Error(res.data.msg));
                    }
                }
            } else {
                callback();
            }
        };
        return {
            reayName: "",
            btnText: "添加",
            addName: "添加学科",
            // 添加学科的添加按钮
            addDepClick: true,
            addDepClickKing: false,
            // 查询用的业务名称
            searchForm: {
                nameLike: "",
            },
            // 添加学科
            AddDateModel: {
                // 学科名称
                name: "",
                text: "",
            },
            AddDateRules: {
                name: [
                    { required: true, validator: nameSpace, trigger: "blur" },
                    // {
                    //     required: true,
                    //     message: "请输入学科名称",
                    //     trigger: "blur",
                    // },
                ],
            },
            // 点击添加学科弹出框
            AdddialogVisible: false,
            // 学科管理的分页
            // 当前页数
            pageNum: 1,
            // 每页显示条数
            pageSize: 10,
            // 总数
            total: 1,
            // 表格数据
            tableData: [],
            // 医院id
            hospitalId: window.sessionStorage.getItem("hospitalId"),
            // 学科用户点击修改的id
            userId: "",
            keshiid: "",
            // 学科id
            keshiUserid: "",
        };
    },
    created() {
        this.getDepartmentList();
    },
    methods: {
        change(e) {
            this.$forceUpdate(e);
        },
        // 搜索框
        searchList() {
            this.pageNum = 1;
            this.getDepartmentList();
        },
        // 学科管理分页
        handleCurrentChange(val) {
            this.pageNum = val;
            // console.log(`当前页: ${val}`);
            this.getDepartmentList();
        },
        // 点击添加学科
        depaddKeshi() {
            this.AdddialogVisible = true;
        },
        // 点击添加学科的时候取消正则
        AdddialogVisibleClose() {
            this.addName = "添加学科";
            this.btnText = "添加";
            this.reayName = "";
            this.AdddialogVisible = false;
            this.$refs.AddDateRef.resetFields();
            this.AddDateModel = {
                // 学科名称
                name: "",
                text: "",
            };
        },
        parmen() {
            if (this.btnText == "添加") {
                this.addKeshi();
            } else if (this.btnText == "修改") {
                this.editdialogKeshi();
            }
        },
        // 点击操作添加学科的添加
        addKeshi() {
            this.$refs.AddDateRef.validate((valid) => {
                if (valid) {
                    this.addDepClick = false;
                    this.addDepClickKing = true;
                    let data = _qs.stringify({
                        name: this.AddDateModel.name,
                        remark: this.AddDateModel.text,
                    });
                    this.addDepartment(data);
                }
            });
        },
        // 点击操作删除
        async deleteKeshi(row) {
            const confirmResult = await this.$confirm("确认删除？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).catch((err) => err);

            if (confirmResult !== "confirm") {
                return this.$message.info("已经取消删除");
            }
            let data = _qs.stringify({
                id: row.id,
            });
            let { data: res } = await this.$axios.delehosdpl(data);
            // console.log(res);
            if (res.code == 401) {
                this.$router.push("/login");
            } else if (res.code == 200) {
                this.$message({
                    message: "删除成功",
                    type: "success",
                });
                this.getDepartmentList();
            } else {
                this.$message({
                    message: res.msg,
                    type: "error",
                });
            }
        },
        // 点击操作修改学科的添加
        editKeshi(row) {
            this.addName = "修改学科";
            this.btnText = "修改";
            this.keshiid = row.id;
            this.AddDateModel.name = row.name;
            this.reayName = row.name;
            this.AddDateModel.text = row.remark;
            this.AdddialogVisible = true;
        },
        // 点击修改学科用户管理的添加
        editdialogKeshi() {
            this.$refs.AddDateRef.validate((valid) => {
                if (!valid) return;
                this.addDepClick = false;
                this.addDepClickKing = true;
                let data = _qs.stringify({
                    name: this.AddDateModel.name, //学科名称
                    remark: this.AddDateModel.text,
                    id: this.keshiid, //学科id
                });
                this.updatehosdpl(data);
            });
        },
        async updatehosdpl(data) {
            let res = await this.$axios.updatehosdpl(data);
            // console.log(res);
            this.addDepClick = true;
            this.addDepClickKing = false;
            if (res.data.code == 401) {
                this.$router.push("/login");
            } else if (res.status == 200) {
                this.AdddialogVisibleClose();
                // 添加学科
                this.AddDateModel = {
                    // 学科名称
                    name: "",
                };
                this.getDepartmentList();
                this.$message({
                    message: res.data.msg,
                    type: "success",
                });
            } else {
                this.$message({
                    message: res.data.msg,
                    type: "error",
                });
            }
        },
        // 添加或修改学科信息接口
        async addDepartment(data) {
            let res = await this.$axios.addhosdpl(data);
            // console.log(res);
            this.addDepClick = true;
            this.addDepClickKing = false;
            if (res.data.code == 401) {
                this.$router.push("/login");
            } else if (res.status == 200) {
                this.AdddialogVisibleClose();
                // 添加学科
                this.AddDateModel = {
                    // 学科名称
                    name: "",
                };
                this.getDepartmentList();
            } else {
                this.$message({
                    message: res.msg,
                    type: "error",
                });
            }
        },
        // 分页显示学科管理数据
        async getDepartmentList() {
            let data = {
                name: this.searchForm.nameLike, // 学科名称
                deleteFlag: "0",
                pageNum: this.pageNum, //页数
                pageSize: this.pageSize, //每页显示条数
            };
            let { data: res } = await this.$axios.listhosdpl(data);
            // console.log(res);
            if (res.code == 401) {
                this.$router.push("/login");
            } else if (res.code == 200) {
                this.tableData = res.rows;
                this.total = res.total;
            }
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
    text-align: inherit;
    .btnCen {
        button {
            width: 150px;
        }
    }
}

.RightDiv {
    margin: 0 auto;
}
.searForm {
    float: right;
}
.depTitle {
    display: flex;
    margin: 0 auto;
    margin-bottom: 20px;
}
.depart-addnum {
    width: 100%;
}

.depar-dia {
    width: 100%;
}

/deep/ .el-radio-button__inner {
    width: 100px;
}
.el-pagination {
    margin-top: 20px;
}
.el-main {
    .table-title {
        display: flex;
        margin-bottom: 10px;
        .index-add {
            margin-left: 20px;
        }
    }
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}

/deep/ .el-textarea__inner {
    width: 220px !important;
}

/deep/ .el-input__inner {
    width: 220px !important;
}
</style>
